<template>
  <div class="row">
    <div class="col">
      <label>Formulários</label>
      <select class="form-select" ref="formularios" v-model="selected">
        <option v-for="item in formularios" :key="item" :value="item">
          {{ item.nomeForm }}
        </option>
      </select>
    </div>
    <div class="col-3">
      <div style="margin-top: 23px; margin-bottom: 10px">
        <button type="button" class="btn btn-primary" @click="selecionarForm" style="margin-right: 10px">Selecionar Formulário</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <component v-bind:is="formBuilderQuestions" v-if="idForm" :idFormProp="idForm" :idRegistroAtendimento="idRegistroAtendimento" @reload-table="getFormsResp"></component>
      <component v-bind:is="formBuilderQuestionsView" v-if="idRespForm" :idFormResp="idRespForm" @reload-table="getFormsResp"></component>
    </div>
    <div class="col-4">
      <a-table :dataSource="formulariosRespondidos" :columns="columns">
        <template #dataRespondido="{ record }">
          <span>{{ formatDate(record.dataResposta) }}</span>
        </template>
        <template #action="{ record }">
          <a @click="editResp(record)"><i class="fas fa-edit icon-edit"></i></a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getFormsBuilder } from '@/components/service/formBuilderService';
import FormBuilderQuestions from '@/components/pages/form-builder/FormBuilderQuestions';
import { getFormRespByIdRegistroAtendimento } from '@/components/service/formBuilderRespostasService';
import { formatarData } from '@/utils/servicos-utils';
import FormBuilderQuestionsView from '@/components/pages/form-builder/FormBuilderQuestionsView';

export default {
  name: 'FormularioAtendimento',
  components: {
    FormBuilderQuestions,
    FormBuilderQuestionsView,
  },
  data() {
    return {
      idRegistroAtendimento: null,
      formBuilderQuestions: FormBuilderQuestions,
      formBuilderQuestionsView: FormBuilderQuestionsView,
      formularios: [],
      idForm: null,
      idRespForm: null,
      selected: null,
      formulariosRespondidos: [],
      columns: [
        {
          title: 'Data',
          dataIndex: 'dataRespondido',
          key: 'dataRespondido',
          slots: { customRender: 'dataRespondido' },
        },
        {
          title: 'Formulário',
          dataIndex: 'nomeForm',
          key: 'nomeForm',
          slots: { customRender: 'nomeForm' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.idRegistroAtendimento = this.$route.query.id;
    await this.getForms();
    await this.getFormsResp();
  },
  methods: {
    async getForms() {
      await getFormsBuilder().then((r) => {
        this.formularios = r.data;
      });
    },
    async getFormsResp() {
      await getFormRespByIdRegistroAtendimento(this.idRegistroAtendimento).then((r) => {
        this.formulariosRespondidos = r.data;
      });
    },
    selecionarForm() {
      this.idForm = null;
      this.idRespForm = null;
      setTimeout(() => {
        this.idForm = this.selected.id;
      }, 500);
    },
    formatDate(data) {
      return formatarData(new Date(data), 'DD/MM/YYYY HH:mm');
    },
    editResp(formResp) {
      this.idForm = null;
      this.idRespForm = null;
      setTimeout(() => {
        this.idRespForm = formResp.id;
      }, 500);
    },
  },
};
</script>

<style scoped></style>
